import * as React from 'react';
import {system_notification} from 'src/store/slice/system';
import store from 'src/storeWire';

const CreateProject = (props) => {

    return (
        <>
            <button className="btn btn-secondary bs5" data-toggle="modal" data-target="#Create-project"
                    onClick={async () => {
                        store.dispatch(system_notification({
                            name: 'BomCreateProjectPopup',
                            data: {
                                props_afterBOMCreation: props.afterBOMCreation
                            },
                        }));
                    }}><i aria-hidden="true" className="fa fa-plus"></i> Create a Project
            </button>
        </>
    );
};

export default CreateProject;